var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-wrapper"},[_c('ElMenu',{staticClass:"sidebar-container"}),_c('div',{staticClass:"main-container"},[_c('AppContent',{staticClass:"app-main"})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }